'use client'

/**
 * Layout fuer /podcast — FglHeader + Award-Background, analog /sync.
 * Root-Layout rendert FglFooter fuer Public-Pfade, deshalb hier kein
 * eigener Footer.
 */

import { FglHeader } from '@/components/layout/fgl-header'

export default function PodcastLayout({ children }: { children: React.ReactNode }) {
  return (
    <div data-award="true" className="min-h-screen" style={{ background: 'var(--award-ink)' }}>
      <FglHeader />
      {children}
    </div>
  )
}
